const appInfo = {
	title: import.meta.env.VITE_TITLE as string,
};
export default appInfo;
